<!-- Start FAQ Area -->
<section class="faq-area ptb-100 bg-ffffff">
    <div class="container">
        <div class="section-title">
            <!-- <span>Ask Questions</span> -->
            <h2>Frequently Asked Questions</h2>
            <p>
                Find answers to common questions about solar installation,
                system types, savings, maintenance, and our solar services.
            </p>
        </div>
        <div class="row align-items-center">
            <!-- FAQ Intro -->
            <div class="col-lg-5 col-md-12">
                <div class="faq-content">
                    <div class="faq-image">
                        <img src="assets/image/faq.png" alt="SOLARCITI Solar Solutions" />
                    </div>

                    <div class="faq-contact-box">
                        <span>Still have questions?</span>
                        <h3>Let's find the right solar solution for you.</h3>
                        <a routerLink="/contact" class="btn btn-primary">
                            Get a Free Consultation
                            <i class="flaticon-right"></i>
                        </a>
                    </div>
                </div>
            </div>

            <!-- FAQ Accordion -->
            <div class="col-lg-7 col-md-12">
                <div class="faq-accordion">
                    <ul class="accordion">

                        <li class="accordion-item" *ngFor="let faq of faqList">

                            <a class="accordion-title" href="javascript:void(0)">

                                <i class="fas fa-plus"></i>

                                {{ faq.question }}
                            </a>

                            <p class="accordion-content">
                                {{ faq.answer }}
                            </p>

                        </li>

                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End FAQ Area -->